<template>
  <b-row>
    <b-col>
      <template v-if="openInModal">
        <b-row v-if="isLoading && !retrieved">
          <b-col>
            <Loader size="lg"></Loader>
          </b-col>
        </b-row>
        <EXSBInvoiceForm
                v-else-if="item"
                :editType="editType"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations"
                :initial-values="retrieved" />
      </template>
      <template v-else>
        <b-row>
          <b-col>
            <button @click="$router.go(-1)" class="btn btn-default float-right">{{ $t('buttons.goBack') }}</button>
          </b-col>
        </b-row>
        <b-row v-if="isLoading && !retrieved">
          <b-col>
            <Loader size="lg"></Loader>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col>
            <b-card>
              <div class="card-body">
                <b-row>
                  <b-col>
                    <EXSBInvoiceForm
                            v-if="item"
                            :editType="editType"
                            :handle-submit="onSendForm"
                            :handle-update-field="updateField"
                            :values="item"
                            :errors="violations"
                            :initial-values="retrieved" />
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </template>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBInvoiceForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    EXSBInvoiceForm,
    Loader
  },

  props: {
    editType: {
      type: String,
      default: function () { return decodeURIComponent(this.$route.params.type) }
    },
    idInvoice: {
      type: String,
      default: null
    },
    openInModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      prevRoute: null,
      item: {
        totalSums: [],
        invoicePositions: [],
        invoiceType: null,
        paymentWay: null,
        invoiceStatus: null,
        batchNumber: null,
        totalValueNetto: 0.00,
        totalValueBrutto: 0.00,
        totalVatAmount: 0.00,
        toPay: 0.00,
        paid: 0.00
      }
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbinvoice/update/isLoading',
      error: 'exsbinvoice/update/error',
      deleteError: 'exsbinvoice/del/error',
      deleteLoading: 'exsbinvoice/del/isLoading',
      created: 'exsbinvoice/create/created',
      deleted: 'exsbinvoice/del/deleted',
      retrieved: 'exsbinvoice/update/retrieved',
      updated: 'exsbinvoice/update/updated',
      violations: 'exsbinvoice/update/violations'
    })
    // invoiceUpdated () {
    //   return this.$store.state.modals.exsbinvoices.update.invoiceReload
    // }
  },

  watch: {
    updated () {
      if (this.openInModal) {
        this.$store.state.modals.exsbinvoices.update.dataUpdateClose = 1
        this.$store.state.modals.exsbinvoices.update.invoiceReload = 1
      } else if (this.prevRoute) {
        this.$router.push(this.prevRoute)
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBInvoiceList' })
    },
    retrieved: function () {
      if (this.retrieved.invoiceType && this.retrieved.invoiceType['@id']) {
        this.retrieved.invoiceType = this.retrieved.invoiceType['@id']
      }
      if (this.retrieved.batchNumber && this.retrieved.batchNumber['@id']) {
        this.retrieved.batchNumber = this.retrieved.batchNumber['@id']
      }
      if (this.retrieved.firm && this.retrieved.firm['@id']) {
        this.retrieved.firm = this.retrieved.firm['@id']
      }
      if (this.retrieved.invoiceStatus && this.retrieved.invoiceStatus['@id']) {
        this.retrieved.invoiceStatus = this.retrieved.invoiceStatus['@id']
      }
      if (this.retrieved.paymentWay && this.retrieved.paymentWay['@id']) {
        this.retrieved.paymentWay = this.retrieved.paymentWay['@id']
      }
      if (this.retrieved.invoiceCorrectionOf && this.retrieved.invoiceCorrectionOf['@id']) {
        this.retrieved.invoiceCorrectionOf = this.retrieved.invoiceCorrectionOf['@id']
      }
      if (this.retrieved.idUserData && this.retrieved.idUserData['@id']) {
        this.retrieved.idUserData = this.retrieved.idUserData['@id']
      }
      if (this.editType === 'data') {
        delete this.retrieved.invoicePositions
      }
      if (this.retrieved.invoicePositions) {
        for (let i in this.retrieved.invoicePositions) {
          if (this.retrieved.invoicePositions[i].item && this.retrieved.invoicePositions[i].item['@id']) {
            this.retrieved.invoicePositions[i].item = this.retrieved.invoicePositions[i].item['@id']
          } else {
            this.retrieved.invoicePositions[i].isCustom = true
          }
          if (this.retrieved.invoicePositions[i].measure && this.retrieved.invoicePositions[i].measure['@id']) {
            this.retrieved.invoicePositions[i].measure = this.retrieved.invoicePositions[i].measure['@id']
          }
          if (this.retrieved.invoicePositions[i].vatRate && this.retrieved.invoicePositions[i].vatRate['@id']) {
            this.retrieved.invoicePositions[i].vatRate = this.retrieved.invoicePositions[i].vatRate['@id']
          }
          if (this.retrieved.invoicePositions[i].discount > 0) {
            this.retrieved.invoicePositions[i].hasDiscount = true
          }
        }
      }
      this.retrieved.totalValueNetto = this.retrieved.totalValueNetto.toString()
      this.retrieved.totalValueBrutto = this.retrieved.totalValueBrutto.toString()
      this.retrieved.totalVatAmount = this.retrieved.totalVatAmount.toString()
      this.retrieved.paid = this.retrieved.paid.toString()
    }
  },

  beforeCreate () {
    checkPagePermission('finances', 'EXSBInvoiceUpdate')
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    if (this.idInvoice > 0) {
      this.retrieve(decodeURIComponent('/core/public/index.php/api/e_x_s_b_invoices/' + this.idInvoice))
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'exsbinvoice/create/reset',
      deleteItem: 'exsbinvoice/del/del',
      delReset: 'exsbinvoice/del/reset',
      retrieve: 'exsbinvoice/update/retrieve',
      updateReset: 'exsbinvoice/update/reset',
      update: 'exsbinvoice/update/update',
      updateRetrieved: 'exsbinvoice/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbinvoice ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      // let item = this.item
      // delete this.item.invoicePositions
      // this.item = item
      // let item = Object.assign({}, this.item)
      let item = JSON.parse(JSON.stringify(this.retrieved))
      for (let p in item.invoicePositions) {
        item.invoicePositions[p].quantity = parseFloat(item.invoicePositions[p].quantity)
        item.invoicePositions[p].priceNettoPerUnit = (item.invoicePositions[p].priceNettoPerUnit).toString()
        item.invoicePositions[p].priceBruttoPerUnit = (item.invoicePositions[p].priceBruttoPerUnit).toString()
        item.invoicePositions[p].valueNetto = (item.invoicePositions[p].valueNetto).toString()
        item.invoicePositions[p].valueBrutto = (item.invoicePositions[p].valueBrutto).toString()
        if (item.invoicePositions[p].discount || item.invoicePositions[p].discount === 0) {
          item.invoicePositions[p].discount = (item.invoicePositions[p].discount).toString()
        } else {
          item.invoicePositions[p].discount = null
        }
        item.invoicePositions[p].vatAmount = (item.invoicePositions[p].vatAmount).toString()
      }
      item.paid = item.paid.toString()
      item.toPay = item.toPay.toString()
      item.totalVatAmount = item.totalVatAmount.toString()
      this.update(item)
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
